import { Field, Input } from '@chakra-ui/react';
import type { FieldProps } from './helpers';

interface EditBaseProps extends FieldProps {}

const EditBase = ({ user, form }: EditBaseProps) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = form;
  return (
    <>
      <Field.Root invalid={!!errors.firstName}>
        <Input
          background="white"
          border="none"
          maxLength={32}
          {...register('firstName', { required: t('profile.firstName') })}
          placeholder={t('profile.firstName')}
          _placeholder={{ color: 'fg.subtle' }}
          defaultValue={user?.first_name}
          autoComplete="off"
        />
        <Field.ErrorText>{errors?.firstName?.message as string}</Field.ErrorText>
      </Field.Root>

      <Field.Root invalid={!!errors.lastName}>
        <Input
          background="white"
          border="none"
          maxLength={32}
          {...register('lastName')}
          placeholder={t('profile.lastName')}
          _placeholder={{ color: 'fg.subtle' }}
          defaultValue={user?.last_name}
          autoComplete="off"
        />
      </Field.Root>
    </>
  );
};

export { EditBase };
